import React from 'react';
import * as S from '../SrpFilters/SrpFilters.styles';
import ArrowDropDownIcon from '../../../../Icons/ArrowDropDownIcon';

const SrpFilters = () => (
  <S.SrpFiltersWrapDiv>
    <S.FilterTextWrapDiv>
      <S.FirstLoadderInnerDiv>
        <S.FirstLoaderWrapSpan />
        <S.SecondLoaderWrapSpan />
      </S.FirstLoadderInnerDiv>
      <S.HotelShowDiv />
    </S.FilterTextWrapDiv>
    <S.FilterContentWrapDiv>
      <S.FirstLoadderInnerDiv>
        <S.RowCentered>
          {/* <ArrowDropDownIcon /> */}
          <S.PopularFilterSpan />
        </S.RowCentered>
        <S.SecondLoaderWrapSpan />
      </S.FirstLoadderInnerDiv>
      <S.HotelFilterDiv />
      <S.HotelFilterDiv />
    </S.FilterContentWrapDiv>
    <S.FilterContentWrapDiv>
      <S.FirstLoadderInnerDiv>
        <S.RowCentered>
          {/* <ArrowDropDownIcon /> */}
          <S.PopularFilterSpan />
        </S.RowCentered>
        <S.SecondLoaderWrapSpan />
      </S.FirstLoadderInnerDiv>
      <S.HotelFilterDiv />
      <S.HotelFilterDiv />
    </S.FilterContentWrapDiv>
    <S.FilterContentWrapDiv>
      <S.FirstLoadderInnerDiv>
        <S.RowCentered>
          {/* <ArrowDropDownIcon /> */}
          <S.PopularFilterSpan />
        </S.RowCentered>
        <S.SecondLoaderWrapSpan />
      </S.FirstLoadderInnerDiv>
      <S.HotelFilterDiv />
      <S.HotelFilterDiv />
    </S.FilterContentWrapDiv>
    <S.FilterContentWrapDiv>
      <S.FirstLoadderInnerDiv>
        <S.RowCentered>
          {/* <ArrowDropDownIcon /> */}
          <S.PopularFilterSpan />
        </S.RowCentered>
        <S.SecondLoaderWrapSpan />
      </S.FirstLoadderInnerDiv>
      <S.HotelFilterDiv />
      <S.HotelFilterDiv />
    </S.FilterContentWrapDiv>
    <S.FilterContentWrapDiv>
      <S.FirstLoadderInnerDiv>
        <S.RowCentered>
          {/* <ArrowDropDownIcon /> */}
          <S.PopularFilterSpan />
        </S.RowCentered>
        <S.SecondLoaderWrapSpan />
      </S.FirstLoadderInnerDiv>
      <S.HotelFilterDiv />
      <S.HotelFilterDiv />
    </S.FilterContentWrapDiv>
  </S.SrpFiltersWrapDiv>
);

export default SrpFilters;
